import { create } from "zustand";
import { persist } from "zustand/middleware";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "@/db/firebase/client";
import { onAuthStateChanged, User } from "firebase/auth";
import { UserProfile } from "@/types/user";

interface AuthState {
  user: User | null;
  profile: UserProfile | null;
  setUser: (user: User | null) => void;
  setProfile: (profile: UserProfile | null) => void;
  fetchProfile: (uid: string) => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      profile: null,

      setUser: (user) => set({ user }),
      setProfile: (profile) => set({ profile }),

      fetchProfile: async (uid) => {
        const snap = await getDoc(doc(db, "users", uid));
        if (snap.exists()) {
          set({ profile: { uid, ...snap.data() } as UserProfile });
        }
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({ profile: state.profile }),
    }
  )
);

export const initAuthListener = () => {
  onAuthStateChanged(auth, async (user) => {
    const store = useAuthStore.getState();
    store.setUser(user);

    if (user) {
      await store.fetchProfile(user.uid);
    } else {
      store.setProfile(null);
    }
  });
};
